import { combineReducers } from 'redux'
import player from '~/player/reducers.js'
import { programsFM, programsZD, programs, selectedProgramSlug, selectedEpisodeDate, onAirFM, onAirZD } from '~/programs/reducers.js'
import { stories, newsSlides, zedlines } from '~/news/reducers.js'
import { albums, reviews, podcasts } from '~/reviews/reducers.js'
import { nodes, forms } from '~/nodes/reducers.js'
import { events } from '~/events/reducers.js'
import { communityNotices, subDiscountOutlets, subBands, taxonomies } from '~/community/reducers.js'
import { top20, hot100, hot100Archive, prizes, radiothonDaily, stationUpdates, BNA, AOTW, EOYTop10, podcastFeed } from '~/features/reducers.js'
import { search, routes } from '~/menu/reducers.js'

const rootReducer = combineReducers({
  nodes,
  forms,
  events,
  albums,
  reviews,
  podcasts,
  stories,
  newsSlides,
  zedlines,
  programsFM,
  programsZD,
  programs,
  selectedProgramSlug,
  selectedEpisodeDate,
  player,
  onAirFM,
  onAirZD,
  communityNotices,
  subDiscountOutlets,
  subBands,
  taxonomies,
  top20,
  hot100,
  hot100Archive,
  prizes,
  radiothonDaily,
  stationUpdates,
  search,
  routes,
  BNA,
  AOTW,
  EOYTop10,
	podcastFeed
})
 
export default rootReducer
